import type { TooltipPlacement } from '@skupreme/shared/ui';

/* Semantic Popup positions, as React Aria placements. */
const PLACEMENTS: Record<string, TooltipPlacement> = {
  'top center': 'top',
  'top left': 'top start',
  'top right': 'top end',
  'bottom center': 'bottom',
  'bottom left': 'bottom start',
  'bottom right': 'bottom end',
  'left center': 'left',
  'right center': 'right',
};

/** A Semantic `position` as a kit placement; anything unknown or falsy is the top. */
export function toPlacement(
  position?: string | false | null,
): TooltipPlacement {
  return (position && PLACEMENTS[position]) || 'top';
}
